import { render, staticRenderFns } from "./yoyCompare.vue?vue&type=template&id=5cc25f10"
import script from "./yoyCompare.vue?vue&type=script&lang=js"
export * from "./yoyCompare.vue?vue&type=script&lang=js"
import style0 from "./yoyCompare.vue?vue&type=style&index=0&id=5cc25f10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports